import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import InvoiceFoo from '../../components/Invoice/InvoiceFoo';
import { InvoiceViewModel } from '../../models/Invoice/InvoiceViewModel';

export default function InvoicesEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  const [invoice, setInvoice] = useState(null as unknown as InvoiceViewModel);

  /**
   * {
   *   "createdAt": "2023-03-20T18:49:46-03:00",
   *   "updatedAt": "2023-03-20T18:49:46-03:00",
   *   "id": 4,
   *   "isSigned": false,
   *   "statusId": 10,
   *   "statusLabel": "Rascunho",
   *   "statusState": 0,
   *   "companyType": 2,
   *   "companyIdentifier": "59680379035",
   *   "companyName": "adfspkuhn ;kldfskj ;;d",
   *   "customerType": 2,
   *   "customerIdentifier": "05122277303",
   *   "customerName": "awa",
   *   "invoiceProducts": [],
   *   "invoiceServices": []
   *   "invoiceEquipments": []
   * }
   */
  async function getInvoice() {
    if (organization && id) {
      const response = await api.get(
        `organizations/${organization.id}/invoices/${id}`
      );
      setInvoice(new InvoiceViewModel(response.data));
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getInvoice();
  }, [organization, id]);

  return invoice ? (
    <InvoiceFoo
      isLoading={isLoading}
      invoice={invoice}
      refreshInvoice={() => getInvoice()}
      onSubmit={() => {}}
    />
  ) : (
    <div>Carregando...</div>
  );
}
